const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/thank-you"],
    exact: true,
    component: "ThankYou",
  },
  {
    path: ["/events/2026-night-shift-walk"],
    exact: true,
    component: "NightShiftWalk",
  },
];

export default routes;
